import { Close } from '@mui/icons-material'
import { Button, Grid2, IconButton, MenuItem, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../../utils/axios'
import { enqueueSnackbar } from 'notistack'
import { useApp } from '../../../contexts/AppContext'

export default function UserInvite() {
    const navigate = useNavigate()
    const {translate} = useApp()

    const [role, setRole] = useState('')
    const [email, setEmail] = useState('')
    const [inviting, setInviting] = useState(false)

    const sendInvite = () => {
        if (!submitValid()) return
        setInviting(true)
        api.post('/users/invitation', { role, email }, { meta: { showSnackbar: true } }).then(() => {
            setRole('')
            setEmail('')
        }).catch(console.error).finally(() => setInviting(false))
    }

    const submitValid = () => (role && role !== 'select' && email)

    return (
        <Grid2 container padding={2} flexDirection={'column'} height={'100%'}>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'}>
                        {translate("Invite User")}
                    </Typography>
                </Grid2>
                <Grid2>
                    <IconButton onClick={() => navigate('/system/users')}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Grid2 container size='grow' justifyContent={'center'} alignItems={'center'} >
                <Grid2 container size='grow' flexDirection={'column'} gap={3} maxWidth={400} >
                    <Grid2>
                        <TextField required select fullWidth size='small' value={role || 'select'} onChange={(e) => setRole(e.target.value)}>
                            <MenuItem value='select'>{translate("Select Role")}</MenuItem>
                            <MenuItem value='manager'>{translate("Manager")}</MenuItem>
                            <MenuItem value='employee'>{translate("Employee")}</MenuItem>
                        </TextField>
                    </Grid2>
                    <Grid2>
                        <TextField required fullWidth size='small' label={translate('Email')} value={email} onChange={e => setEmail(e.target.value)} />
                    </Grid2>
                    <Grid2>
                        <Button disabled={inviting || !submitValid()} variant='contained' fullWidth size='small' onClick={sendInvite}>
                            {translate("Send Invitation")}
                        </Button>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    )
}